import { Component, OnInit, Input } from '@angular/core';


import { BuyService } from '../../../services/buyservice'
@Component({
  selector: 'app-ordered',
  templateUrl: './ordered.component.html',
  styleUrls: ['./ordered.component.css']
})
export class OrderedComponent implements OnInit {

  
  constructor(private buy: BuyService) { }

  ngOnInit() {
   
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/ordered/ordered.component.ts